import React from 'react';
import { formatAgo, formatViews, videoThumbnail, videoUrl } from '../utils/video';
import type { Video } from '../types/video';
interface VideoCardProps {
  video: Video;
  size?: 'default' | 'large';
}
export function VideoCard({
  video,
  size = 'default'
}: VideoCardProps) {
  const large = size === 'large';
  return <a href={videoUrl(video)} target="_blank" rel="noopener noreferrer" className="group flex h-full flex-col rounded-2xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ember" data-id="element-182" data-mp="1jdgpu6nkvf7n">
      <div className="relative aspect-video overflow-hidden rounded-2xl bg-surface" data-id="element-183" data-mp="1x4c4y0oo6sjo">
        <img src={videoThumbnail(video)} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-184" data-mp="2235i1s01ohjb" />
        <span className="absolute bottom-2.5 right-2.5 rounded-md bg-ink/85 px-1.5 py-0.5 text-xs font-bold tabular-nums text-paper" data-id="element-185" data-mp="2c0td6j1kbr20">
          {video.duration}
        </span>
      </div>
      <h3 className={`mt-4 line-clamp-2 font-semibold leading-snug text-paper transition-colors duration-150 group-hover:text-ember ${large ? 'font-display text-2xl md:text-3xl' : 'text-base'}`} data-id="element-186" data-mp="3tuoc7j2kstyk">
        {video.title}
      </h3>
      <p className={`mt-auto pt-2 text-muted ${large ? 'text-base' : 'text-sm'}`} data-id="element-187" data-mp="3kvje2duxf2mx">
        {formatViews(video.views)} · {formatAgo(video.publishedAt)}
      </p>
    </a>;
}